var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-fill"},[(_vm.mode === 'view' || _vm.mode === 'edit')?_c('div',{staticClass:"d-flex flex-fill"},[_vm._v("\n    "+_vm._s(_vm.data == null ? '-' : _vm.value)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }